// extracted by mini-css-extract-plugin
module.exports = {"title":"ArtworksSection_title__rXY9x","result":"ArtworksSection_result__mDoAi"};